import React from 'react';
import { Link } from 'react-router-dom';
import Header2 from "../../components/Header2/Header2";
import PageTitle from "../../components/pagetitle/PageTitle";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/software-company-components/Footer/Footer";
import SEO from "../../components/SEO";
import "../../css/animate.css";

function ContactCenterDesign() {
  return (
    <div>
      <SEO
            title="Grow Your Business Online with Unified Consulting Services"
            description="Unified Consulting Services helps you grow your business online with proven SEO, paid ads, and social media strategies tailored to your goals."
            url="https://www.ufsnetworks.com/digital-marketing"
            image="https://texora.s3.ap-south-1.amazonaws.com/ufs_logo.jpg"
            canonicalUrl="https://www.ufsnetworks.com/digital-marketing"
        />
        <Header2 />
        <main >
            <PageTitle
                pageTitle={"Transform Customer Experiences with AI-Driven Contact Centers & Intuitive Design"}
                pagesub={"Contact Center And Designing"}
                pageTop={""}
            />
            </main>
            <div className='bannerContainer'>
              <div className='leftSection'>
                  <h2 className='heading fs40'>Transform Customer Experiences with AI-Driven Contact Centers & Intuitive Design</h2>
                  
                  <p className='text'>Empower your brand with intelligent communication and user-first design. From seamless customer interactions to visually stunning interfaces, we deliver end-to-end solutions that drive engagement and satisfaction.</p>
                  <div className='mt-4'>
                      <Link to="/contact" className='contactBtn'>Get in touch</Link>
                  </div>
              </div>
            </div>
            <div className='grid-container'>
              <div className='' style={{border:"solid 1px #ccc", padding:"24px"}}>
                <h4>Smarter Customer Engagement Starts Here</h4>
                <p>Our AI-powered Contact Center solutions are built to handle high-volume support, boost efficiency, and enhance customer satisfaction. Whether it's voice, chat, email, or social, we integrate all channels into a unified system with intelligent automation and real-time insights.</p>
                <h6>🔹 Features:</h6>
                <ul>
                  <li>Omnichannel Communication (Voice, Chat, Email, Social)</li>
                  <li>AI Chatbots & IVR Systems</li>
                  <li>Smart Routing & Real-Time Analytics</li>
                  <li>CRM & Ticketing System Integration</li>
                  <li>24/7 Global Support Infrastructure</li>
                </ul>
              </div>
              <div className='' style={{border:"solid 1px #ccc", padding:"24px"}}>
                <h4>Design Experiences That Matter</h4>
                <p>We don’t just create interfaces—we design journeys. Our UX and UI experts craft intuitive, visually compelling digital products tailored to your users’ needs and behaviors.</p>
                <h6>🔹 What We Offer:</h6>
                <ul>
                  <li>User Research & Persona Mapping</li>
                  <li>Wireframing & Prototyping</li>
                  <li>Mobile-First & Responsive Design</li>
                  <li>Visual Branding & Component Design Systems</li>
                  <li>Usability Testing & Iterative Optimization</li>
                </ul>
              </div>
            </div>
            <div class="cta">
                                <h2 className='text-white'>Let’s Build the Future of Customer Experience — Together</h2>
                                <p className='mb-32'>Schedule a free consultation today and see how we can transform your contact center operations and digital presence.</p>
                                <Link to="/contact" className='contactBtn'>Get in touch</Link>
                            </div>
                        
            <Footer/>
      <Scrollbar />
    </div>
  )
}

export default ContactCenterDesign
